import Api from './Api'

export const Home = {
    contact(context, data) {
        return new Promise((resolve, reject) => {
            Api().post('/contact', data).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error.response);
            })
        });
    }
};
